import React, { useState, useEffect, useCallback, useRef } from 'react';
import { API_URL } from '../config';

// ── Componentes base ───────────────────────────────────────────
const InputField = ({ label, type = 'text', placeholder, value, onChange, required = false, error = '' }) => (
  <div style={{marginBottom: '16px'}}>
    <label style={{display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>{label}</label>
    <input
      type={type} placeholder={placeholder} value={value} onChange={onChange} required={required}
      style={{width: '100%', padding: '10px 12px', border: `1px solid ${error ? '#d32f2f' : '#ddd'}`, borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', fontFamily: 'inherit', backgroundColor: error ? '#fff8f8' : 'white'}}
    />
    {error && <div style={{fontSize: '12px', color: '#d32f2f', marginTop: '4px'}}>⚠ {error}</div>}
  </div>
);

const MenuBtn = ({ icon, label, active, onClick }) => (
  <button onClick={onClick} style={{width: '100%', padding: '14px 16px', margin: '8px 0', border: 'none', borderLeft: active ? '4px solid #FF1493' : '4px solid transparent', backgroundColor: active ? '#f0f2f5' : 'transparent', color: '#172b4d', fontSize: '14px', fontWeight: active ? '600' : '500', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', transition: 'all 0.2s'}}>
    <span style={{fontSize: '18px'}}>{icon}</span><span>{label}</span>
  </button>
);

function ConfirmModal({ mensaje, onConfirmar, onCancelar }) {
  return (
    <div style={{position: 'fixed', inset: 0, background: 'rgba(23,43,77,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000}}>
      <div style={{background: '#fff', borderRadius: 12, padding: '32px 28px', maxWidth: 380, width: '90%', boxShadow: '0 8px 32px rgba(0,0,0,0.18)', textAlign: 'center'}}>
        <div style={{fontSize: 36, marginBottom: 12}}>🗑️</div>
        <p style={{color: '#172b4d', fontWeight: 600, fontSize: 16, marginBottom: 8}}>¿Eliminar este registro?</p>
        <p style={{color: '#626f86', fontSize: 14, marginBottom: 24}}>{mensaje}</p>
        <div style={{display: 'flex', gap: 10, justifyContent: 'center'}}>
          <button onClick={onCancelar} style={{padding: '9px 22px', borderRadius: 6, border: '1.5px solid #dfe1e6', background: '#fff', color: '#626f86', fontWeight: 600, cursor: 'pointer', fontSize: 14}}>Cancelar</button>
          <button onClick={onConfirmar} style={{padding: '9px 22px', borderRadius: 6, border: 'none', background: '#d32f2f', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: 14}}>Sí, eliminar</button>
        </div>
      </div>
    </div>
  );
}

const ESTADOS = {
  'negociacion': { label: 'En negociación', color: '#FF8C00', bg: '#FFF4E5' },
  'confirmado':  { label: 'Confirmado',     color: '#0052CC', bg: '#E6F0FF' },
  'completado':  { label: 'Completado',     color: '#006644', bg: '#E3FCEF' },
  'cancelado':   { label: 'Cancelado',      color: '#BF2600', bg: '#FFEBE6' },
};
const TRANSICIONES = {
  'negociacion': ['confirmado', 'cancelado'],
  'confirmado':  ['completado', 'cancelado'],
  'completado':  [],
  'cancelado':   ['negociacion'],
};

function normalizarEstado(estado) {
  if (!estado) return 'negociacion';
  const mapa = { 'en negociación': 'negociacion', 'en negociacion': 'negociacion', 'negociacion': 'negociacion', 'confirmado': 'confirmado', 'completado': 'completado', 'cancelado': 'cancelado' };
  return mapa[estado.toLowerCase()] || 'negociacion';
}

function EstadoBadge({ estado }) {
  const key = normalizarEstado(estado);
  const e = ESTADOS[key];
  return <span style={{display: 'inline-block', padding: '3px 10px', borderRadius: 12, fontSize: 12, fontWeight: 600, color: e.color, background: e.bg, border: `1.5px solid ${e.color}44`, whiteSpace: 'nowrap'}}>{e.label}</span>;
}

function EstadoDropdown({ eventoId, estadoActual, onCambiar }) {
  const [abierto, setAbierto] = useState(false);
  const ref = useRef(null);
  const key = normalizarEstado(estadoActual);
  const opciones = TRANSICIONES[key] || [];
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  if (opciones.length === 0) return <span style={{fontSize: '12px', color: '#626f86', fontStyle: 'italic'}}>Estado final</span>;
  return (
    <div ref={ref} style={{position: 'relative', display: 'inline-block'}}>
      <button onClick={(e) => { e.stopPropagation(); setAbierto(!abierto); }} style={{backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>Cambiar estado ▾</button>
      {abierto && (
        <div style={{position: 'absolute', top: '110%', left: 0, background: 'white', border: '1px solid #e1e4e8', borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.12)', zIndex: 100, minWidth: 160}}>
          {opciones.map(op => {
            const est = ESTADOS[op];
            return (
              <button key={op} onClick={(e) => { e.stopPropagation(); onCambiar(eventoId, op); setAbierto(false); }}
                style={{display: 'block', width: '100%', textAlign: 'left', padding: '10px 14px', border: 'none', background: 'none', cursor: 'pointer', fontSize: '13px', color: est.color, fontWeight: 600}}
                onMouseEnter={e => e.target.style.backgroundColor = est.bg}
                onMouseLeave={e => e.target.style.backgroundColor = 'transparent'}>
                → {est.label}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

function BarraPago({ cobrado, total }) {
  const pct = total > 0 ? Math.min(100, (cobrado / total) * 100) : 0;
  const color = pct === 100 ? '#4caf50' : pct > 0 ? '#FF8C00' : '#e0e0e0';
  return (
    <div style={{margin: '8px 0 4px'}}>
      <div style={{height: 5, background: '#f0f2f5', borderRadius: 3, overflow: 'hidden'}}>
        <div style={{height: '100%', width: `${pct}%`, background: color, borderRadius: 3, transition: 'width 0.4s ease'}} />
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '11px', color: '#626f86', marginTop: 3}}>
        <span>Cobrado: ${cobrado.toFixed(0)}</span>
        <span style={{color: pct < 100 ? '#d32f2f' : '#4caf50', fontWeight: 600}}>{pct === 100 ? '✓ Pagado' : `Pendiente: $${(total - cobrado).toFixed(0)}`}</span>
        <span>Total: ${total.toFixed(0)}</span>
      </div>
    </div>
  );
}

function validarEvento(form) {
  const errs = {};
  if (!form.nombre_evento.trim()) errs.nombre_evento = 'El nombre es requerido';
  if (!form.cliente_id) errs.cliente_id = 'Selecciona un cliente';
  if (!form.fecha_evento) { errs.fecha_evento = 'La fecha es requerida'; }
  else { const hoy = new Date(); hoy.setHours(0,0,0,0); if (new Date(form.fecha_evento) < hoy) errs.fecha_evento = 'La fecha no puede ser en el pasado'; }
  if (!form.precio_total || Number(form.precio_total) <= 0) errs.precio_total = 'El precio debe ser mayor a $0';
  return errs;
}

// ── Selector de cliente con creación rápida ────────────────────
function ClienteSelector({ clientes, value, onChange, error, onClienteCreado, token }) {
  const [modo, setModo] = useState('select');
  const [form, setForm] = useState({ nombre: '', telefono: '', origen: '' });
  const [guardando, setGuardando] = useState(false);
  const [errLocal, setErrLocal] = useState('');

  const guardarNuevo = async () => {
    if (!form.nombre.trim()) { setErrLocal('El nombre es requerido'); return; }
    setGuardando(true); setErrLocal('');
    try {
      const res = await fetch(`${API_URL}/api/clientes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ nombre: form.nombre, telefono: form.telefono, origen: form.origen, email: '', notas: '' })
      });
      if (!res.ok) throw new Error('Error al crear cliente');
      const nuevo = await res.json();
      onClienteCreado(nuevo);
      onChange(String(nuevo.id));
      setModo('select');
      setForm({ nombre: '', telefono: '', origen: '' });
    } catch (err) { setErrLocal('❌ ' + err.message); }
    setGuardando(false);
  };

  return (
    <div style={{marginBottom: '16px'}}>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px'}}>
        <label style={{fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>Cliente *</label>
        {modo === 'select' && (
          <button type="button" onClick={() => setModo('nuevo')} style={{fontSize: '12px', color: '#FF1493', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600', padding: 0}}>
            + Crear cliente nuevo
          </button>
        )}
      </div>

      {modo === 'select' ? (
        <>
          <select value={value} onChange={(e) => onChange(e.target.value)}
            style={{width: '100%', padding: '10px 12px', border: `1px solid ${error ? '#d32f2f' : '#ddd'}`, borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', fontFamily: 'inherit', backgroundColor: error ? '#fff8f8' : 'white'}}>
            <option value="">Selecciona cliente...</option>
            {clientes.map(c => <option key={c.id} value={c.id}>{c.nombre}{c.telefono ? ` — ${c.telefono}` : ''}</option>)}
          </select>
          {error && <div style={{fontSize: '12px', color: '#d32f2f', marginTop: '4px'}}>⚠ {error}</div>}
        </>
      ) : (
        <div style={{border: '1.5px solid #FF1493', borderRadius: '8px', padding: '16px', backgroundColor: '#fff5f8'}}>
          <div style={{fontSize: '12px', fontWeight: '700', color: '#FF1493', marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.04em'}}>✨ Nuevo cliente</div>
          {errLocal && <div style={{fontSize: '12px', color: '#d32f2f', marginBottom: '10px'}}>⚠ {errLocal}</div>}
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '10px'}}>
            <div>
              <label style={{display: 'block', fontSize: '12px', fontWeight: '600', color: '#172b4d', marginBottom: '4px'}}>Nombre *</label>
              <input value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} placeholder="Juan García" style={{width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'inherit'}} />
            </div>
            <div>
              <label style={{display: 'block', fontSize: '12px', fontWeight: '600', color: '#172b4d', marginBottom: '4px'}}>Teléfono</label>
              <input value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} placeholder="3215551234" style={{width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'inherit'}} />
            </div>
          </div>
          <div style={{marginBottom: '12px'}}>
            <label style={{display: 'block', fontSize: '12px', fontWeight: '600', color: '#172b4d', marginBottom: '4px'}}>Origen</label>
            <input value={form.origen} onChange={e => setForm({...form, origen: e.target.value})} placeholder="Instagram, Referido, Facebook..." style={{width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'inherit'}} />
          </div>
          <div style={{display: 'flex', gap: '8px'}}>
            <button type="button" onClick={guardarNuevo} disabled={guardando} style={{flex: 1, padding: '8px 0', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: guardando ? 'not-allowed' : 'pointer', fontSize: '13px', fontWeight: '600', opacity: guardando ? 0.7 : 1}}>
              {guardando ? 'Guardando...' : '✓ Guardar y seleccionar'}
            </button>
            <button type="button" onClick={() => { setModo('select'); setForm({ nombre: '', telefono: '', origen: '' }); setErrLocal(''); }} style={{padding: '8px 14px', backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ── CMS ────────────────────────────────────────────────────────
function SeccionCMS({ token }) {
  const [tab, setTab] = useState('hero');
  const [datos, setDatos] = useState({});
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState('');
  const tabs = [
    { id: 'hero', label: '🦸 Hero' }, { id: 'stats', label: '📊 Stats' },
    { id: 'servicios', label: '✨ Servicios' }, { id: 'galeria', label: '🖼️ Galería' },
    { id: 'testimonio', label: '💬 Testimonio' }, { id: 'cta', label: '📣 CTA Final' },
    { id: 'contacto', label: '📞 Contacto' }, { id: 'footer', label: '🔽 Footer' },
  ];
  useEffect(() => { cargarSeccion(tab); }, [tab]);
  const cargarSeccion = async (s) => {
    setDatos({});
    try { const r = await fetch(`${API_URL}/api/cms/${s}`); setDatos(await r.json()); } catch { setMsg('❌ Error al cargar'); }
  };
  const guardar = async () => {
    setGuardando(true);
    try {
      const r = await fetch(`${API_URL}/api/cms/${tab}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(datos),
      });
      const d = await r.json();
      if (d.success) { setMsg('✅ Cambios guardados'); setTimeout(() => setMsg(''), 3000); }
      else setMsg('❌ ' + (d.error || 'Error al guardar'));
    } catch { setMsg('❌ Error al guardar'); }
    setGuardando(false);
  };
  const cambiar = (campo, valor) => setDatos(prev => ({ ...prev, [campo]: valor }));
  const etiqueta = (c) => c.replace(/_/g, ' ').replace(/\b\w/g, x => x.toUpperCase());
  const esImagen = (c) => c.includes('url') || c.includes('img');
  const esTA = (c) => c.includes('desc') || c.includes('subtitulo') || c.includes('texto') || c.includes('mensaje') || c.includes('tagline');
  return (
    <div>
      <div style={{display: 'flex', gap: 8, marginBottom: 24, flexWrap: 'wrap'}}>
        {tabs.map(t => <button key={t.id} onClick={() => setTab(t.id)} style={{padding: '8px 14px', borderRadius: 20, border: `1px solid ${tab === t.id ? '#FF1493' : '#e1e4e8'}`, background: tab === t.id ? '#FFE4F0' : 'white', color: tab === t.id ? '#FF1493' : '#626f86', cursor: 'pointer', fontWeight: tab === t.id ? 600 : 400, fontSize: 13}}>{t.label}</button>)}
      </div>
      <div style={{background: 'white', border: '1px solid #e1e4e8', borderRadius: 8, padding: 24}}>
        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20}}>
          <h3 style={{margin: 0, color: '#172b4d', fontSize: 16}}>{tabs.find(t => t.id === tab)?.label}</h3>
          <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
            <a href="/" target="_blank" rel="noopener noreferrer" style={{color: '#626f86', fontSize: 13, textDecoration: 'none'}}>👁️ Ver landing →</a>
            <button onClick={guardar} disabled={guardando} style={{background: '#FF1493', color: 'white', border: 'none', borderRadius: 6, padding: '8px 20px', cursor: guardando ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 13, opacity: guardando ? 0.7 : 1}}>{guardando ? 'Guardando...' : '💾 Guardar'}</button>
          </div>
        </div>
        {msg && <div style={{padding: '10px 16px', borderRadius: 6, fontSize: 13, marginBottom: 16, background: msg.startsWith('✅') ? '#e6f4ea' : '#fce8e6', color: msg.startsWith('✅') ? '#137333' : '#c5221f'}}>{msg}</div>}
        {Object.keys(datos).length === 0 ? <p style={{color: '#626f86', fontSize: 14}}>Cargando...</p> : Object.entries(datos).map(([campo, valor]) => (
          <div key={campo} style={{marginBottom: 16}}>
            <label style={{display: 'block', fontSize: 11, color: '#626f86', marginBottom: 4, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px'}}>{etiqueta(campo)}</label>
            {esImagen(campo) ? (
              <div style={{display: 'flex', gap: 8, alignItems: 'center'}}>
                <input value={valor || ''} onChange={e => cambiar(campo, e.target.value)} placeholder="https://..." style={{flex: 1, padding: '8px 12px', border: '1px solid #e1e4e8', borderRadius: 6, fontSize: 12, fontFamily: 'monospace', boxSizing: 'border-box'}} />
                {valor && <img src={valor} alt="" style={{width: 44, height: 44, objectFit: 'cover', borderRadius: 4, border: '1px solid #e1e4e8', flexShrink: 0}} onError={e => { e.target.style.display = 'none'; }} />}
              </div>
            ) : esTA(campo) ? (
              <textarea value={valor || ''} onChange={e => cambiar(campo, e.target.value)} rows={3} style={{width: '100%', padding: '8px 12px', border: '1px solid #e1e4e8', borderRadius: 6, fontSize: 13, resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit'}} />
            ) : (
              <input value={valor || ''} onChange={e => cambiar(campo, e.target.value)} style={{width: '100%', padding: '8px 12px', border: '1px solid #e1e4e8', borderRadius: 6, fontSize: 13, boxSizing: 'border-box'}} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

// ── Sección Inicio con widgets ─────────────────────────────────
function SeccionInicio({ clientes, eventos, setSeccion }) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
  const en7dias = new Date(hoy); en7dias.setDate(hoy.getDate() + 7);
  const mesActual = `${hoy.getFullYear()}-${String(hoy.getMonth() + 1).padStart(2, '0')}`;
  const mesAnt = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
  const mesAntKey = `${mesAnt.getFullYear()}-${String(mesAnt.getMonth() + 1).padStart(2, '0')}`;

  const statsPorEstado = ['negociacion', 'confirmado', 'completado', 'cancelado'].map(key => ({
    key, ...ESTADOS[key],
    count: eventos.filter(e => normalizarEstado(e.estado) === key).length,
  }));

  const totalCobrado = eventos.reduce((a, e) => a + (Number(e.anticipo) || 0) + (Number(e.complemento) || 0), 0);
  const totalPendiente = eventos.reduce((a, e) => { const p = (Number(e.precio_total) || 0) - (Number(e.anticipo) || 0) - (Number(e.complemento) || 0); return a + (p > 0 ? p : 0); }, 0);
  const cobradoMes = eventos.filter(e => (e.fecha_evento || '').startsWith(mesActual)).reduce((a, e) => a + (Number(e.anticipo) || 0) + (Number(e.complemento) || 0), 0);
  const cobradoMesAnt = eventos.filter(e => (e.fecha_evento || '').startsWith(mesAntKey)).reduce((a, e) => a + (Number(e.anticipo) || 0) + (Number(e.complemento) || 0), 0);
  const varPct = cobradoMesAnt > 0 ? Math.round(((cobradoMes - cobradoMesAnt) / cobradoMesAnt) * 100) : null;

  const eventosPorCobrar = eventos.filter(e => { const p = (Number(e.precio_total) || 0) - (Number(e.anticipo) || 0) - (Number(e.complemento) || 0); return p > 0 && normalizarEstado(e.estado) !== 'cancelado'; }).sort((a, b) => new Date(a.fecha_evento) - new Date(b.fecha_evento)).slice(0, 5);

  const proximosEventos = eventos.filter(e => { if (!e.fecha_evento) return false; const f = new Date(e.fecha_evento); f.setHours(0,0,0,0); return f >= hoy && f <= en7dias; }).sort((a, b) => new Date(a.fecha_evento) - new Date(b.fecha_evento)).slice(0, 5);

  const origenCount = clientes.reduce((acc, c) => { const o = (c.origen || 'Sin especificar').trim() || 'Sin especificar'; acc[o] = (acc[o] || 0) + 1; return acc; }, {});
  const origenes = Object.entries(origenCount).sort((a, b) => b[1] - a[1]).slice(0, 5);
  const maxOrigen = origenes[0]?.[1] || 1;

  const meses6 = Array.from({length: 6}, (_, i) => { const d = new Date(hoy.getFullYear(), hoy.getMonth() - (5 - i), 1); return { key: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, label: d.toLocaleString('es-MX', { month: 'short' }) }; });
  const ingresosPorMes = meses6.map(m => ({ ...m, total: eventos.filter(e => (e.fecha_evento || '').startsWith(m.key)).reduce((a, e) => a + (Number(e.precio_total) || 0), 0) }));

  useEffect(() => {
    if (!chartRef.current) return;
    const tryInit = () => {
      if (!window.Chart) { setTimeout(tryInit, 100); return; }
      if (chartInstance.current) { chartInstance.current.destroy(); chartInstance.current = null; }
      chartInstance.current = new window.Chart(chartRef.current, {
        type: 'bar',
        data: {
          labels: ingresosPorMes.map(m => m.label),
          datasets: [{ data: ingresosPorMes.map(m => m.total), backgroundColor: ingresosPorMes.map((_, i) => i === 5 ? '#FF1493' : '#FFB3D4'), borderRadius: 5, borderSkipped: false }]
        },
        options: {
          responsive: true, maintainAspectRatio: false,
          plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => '$' + ctx.raw.toLocaleString('es-MX') } } },
          scales: {
            x: { grid: { display: false }, ticks: { color: '#626f86', font: { size: 11 } } },
            y: { grid: { color: 'rgba(0,0,0,0.05)' }, border: { display: false }, ticks: { color: '#626f86', font: { size: 11 }, callback: v => '$' + (v >= 1000 ? (v / 1000).toFixed(0) + 'k' : v) } }
          }
        }
      });
    };
    tryInit();
    return () => { if (chartInstance.current) { chartInstance.current.destroy(); chartInstance.current = null; } };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventos]);

  const formatFecha = (f) => {
    if (!f) return '—';
    const d = new Date(f); d.setHours(0,0,0,0);
    const diff = Math.round((d - hoy) / 86400000);
    if (diff === 0) return 'Hoy'; if (diff === 1) return 'Mañana';
    return d.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' });
  };

  const KPI = ({ label, valor, sub, subColor }) => (
    <div style={{backgroundColor: '#fff', padding: '18px 20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
      <div style={{fontSize: '11px', color: '#626f86', fontWeight: '600', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.04em'}}>{label}</div>
      <div style={{fontSize: '26px', fontWeight: '700', color: '#172b4d', marginBottom: '4px'}}>{valor}</div>
      {sub && <div style={{fontSize: '12px', color: subColor || '#626f86'}}>{sub}</div>}
    </div>
  );

  return (
    <div>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.min.js" />
      <h1 style={{fontSize: '28px', fontWeight: '700', color: '#172b4d', margin: '0 0 4px 0'}}>Bienvenida 👋</h1>
      <p style={{color: '#626f86', margin: '0 0 28px 0', fontSize: '14px'}}>Resumen de Sonrie Globos</p>

      {/* KPIs */}
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '24px'}}>
        <KPI label="Clientes" valor={clientes.length} sub={`${clientes.filter(c => { const d = new Date(c.fecha_creacion); const n = new Date(); return d.getMonth() === n.getMonth() && d.getFullYear() === n.getFullYear(); }).length} nuevos este mes`} />
        <KPI label="Eventos activos" valor={eventos.filter(e => ['negociacion','confirmado'].includes(normalizarEstado(e.estado))).length} sub={`de ${eventos.length} en total`} />
        <KPI label={`Cobrado — ${new Date().toLocaleString('es-MX',{month:'long'})}`} valor={`$${cobradoMes.toLocaleString('es-MX')}`} sub={varPct !== null ? `${varPct >= 0 ? '+' : ''}${varPct}% vs mes anterior` : 'Sin datos anteriores'} subColor={varPct !== null ? (varPct >= 0 ? '#2e7d32' : '#d32f2f') : '#626f86'} />
        <KPI label="Por cobrar" valor={`$${totalPendiente.toLocaleString('es-MX')}`} sub={`${eventosPorCobrar.length} eventos con saldo`} subColor={totalPendiente > 0 ? '#d32f2f' : '#2e7d32'} />
      </div>

      {/* Gráfico barras + Estados */}
      <div style={{display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: '16px', marginBottom: '20px'}}>
        <div style={{backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize: '14px', fontWeight: '600', color: '#172b4d', marginBottom: '16px'}}>Ingresos por mes (últimos 6 meses)</div>
          <div style={{position: 'relative', height: '180px'}}>
            <canvas ref={chartRef} role="img" aria-label="Gráfica de barras de ingresos de los últimos 6 meses" />
          </div>
        </div>
        <div style={{backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize: '14px', fontWeight: '600', color: '#172b4d', marginBottom: '16px'}}>Eventos por estado</div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
            {statsPorEstado.map(s => (
              <div key={s.key} style={{display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer'}} onClick={() => setSeccion('eventos')}>
                <div style={{width: 10, height: 10, borderRadius: 2, backgroundColor: s.color, flexShrink: 0}} />
                <div style={{flex: 1, fontSize: '13px', color: '#626f86'}}>{s.label}</div>
                <div style={{fontSize: '14px', fontWeight: '700', color: s.color, minWidth: 20, textAlign: 'right'}}>{s.count}</div>
                <div style={{width: '80px', height: 6, background: '#f0f2f5', borderRadius: 3, overflow: 'hidden'}}>
                  <div style={{height: '100%', width: `${eventos.length > 0 ? (s.count / eventos.length) * 100 : 0}%`, backgroundColor: s.color, borderRadius: 3}} />
                </div>
              </div>
            ))}
            <div style={{borderTop: '1px solid #f0f2f5', paddingTop: '10px', marginTop: '2px', display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#626f86'}}>
              <span>Total cobrado</span><span style={{fontWeight: '700', color: '#172b4d'}}>${totalCobrado.toLocaleString('es-MX')}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Próximos + Cobros */}
      <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px'}}>
        <div style={{backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px'}}>
            <div style={{fontSize: '14px', fontWeight: '600', color: '#172b4d'}}>📅 Próximos 7 días</div>
            <button onClick={() => setSeccion('eventos')} style={{fontSize: '12px', color: '#FF1493', background: 'none', border: 'none', cursor: 'pointer', fontWeight: '600'}}>Ver todos →</button>
          </div>
          {proximosEventos.length === 0 ? <p style={{fontSize: '13px', color: '#626f86', margin: 0}}>Sin eventos esta semana 🎉</p> : (
            <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
              {proximosEventos.map(e => (
                <div key={e.id} style={{display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderRadius: '6px', backgroundColor: '#f8f9fa'}}>
                  <div style={{fontSize: '12px', color: '#626f86', width: '56px', flexShrink: 0, fontWeight: '600'}}>{formatFecha(e.fecha_evento)}</div>
                  <div style={{flex: 1, fontSize: '13px', color: '#172b4d', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{e.nombre_evento}</div>
                  <EstadoBadge estado={e.estado} />
                </div>
              ))}
            </div>
          )}
        </div>
        <div style={{backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize: '14px', fontWeight: '600', color: '#172b4d', marginBottom: '14px'}}>💰 Cobros pendientes</div>
          {eventosPorCobrar.length === 0 ? <p style={{fontSize: '13px', color: '#2e7d32', margin: 0}}>✅ Todo al corriente</p> : (
            <>
              <div style={{display: 'flex', flexDirection: 'column', gap: '2px'}}>
                {eventosPorCobrar.map(e => {
                  const pend = (Number(e.precio_total) || 0) - (Number(e.anticipo) || 0) - (Number(e.complemento) || 0);
                  return (
                    <div key={e.id} style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 0', borderBottom: '1px solid #f0f2f5'}}>
                      <div style={{flex: 1, fontSize: '13px', color: '#172b4d', fontWeight: '500', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{e.nombre_evento}</div>
                      <div style={{fontSize: '11px', color: '#626f86', flexShrink: 0}}>{formatFecha(e.fecha_evento)}</div>
                      <div style={{fontSize: '13px', fontWeight: '700', color: '#d32f2f', flexShrink: 0}}>${pend.toLocaleString('es-MX')}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{display: 'flex', justifyContent: 'space-between', paddingTop: '10px', fontSize: '13px', borderTop: '1px solid #e1e4e8', marginTop: '4px'}}>
                <span style={{color: '#626f86'}}>Total pendiente</span>
                <span style={{fontWeight: '700', color: '#d32f2f'}}>${totalPendiente.toLocaleString('es-MX')}</span>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Origen de clientes */}
      {origenes.length > 0 && (
        <div style={{backgroundColor: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
          <div style={{fontSize: '14px', fontWeight: '600', color: '#172b4d', marginBottom: '16px'}}>📣 Fuente de clientes</div>
          <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
            {origenes.map(([origen, count]) => (
              <div key={origen} style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                <div style={{fontSize: '12px', color: '#626f86', width: '100px', textAlign: 'right', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{origen}</div>
                <div style={{flex: 1, height: '8px', background: '#f0f2f5', borderRadius: 4, overflow: 'hidden'}}><div style={{height: '100%', width: `${(count / maxOrigen) * 100}%`, background: '#FF1493', borderRadius: 4}} /></div>
                <div style={{fontSize: '12px', fontWeight: '600', color: '#172b4d', width: '24px', textAlign: 'right', flexShrink: 0}}>{count}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ══════════════════════════════════════════════════════════════
// Dashboard principal
// ══════════════════════════════════════════════════════════════
function Dashboard({ usuario, token, onLogout }) {
  const [seccion, setSeccion] = useState('inicio');
  const [clientes, setClientes] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [eventoExpandido, setEventoExpandido] = useState(null);
  const [mostrarFormCliente, setMostrarFormCliente] = useState(false);
  const [mostrarFormEvento, setMostrarFormEvento] = useState(false);
  const [editandoCliente, setEditandoCliente] = useState(null);
  const [editandoEvento, setEditandoEvento] = useState(null);
  const [editandoAnticipo, setEditandoAnticipo] = useState(null);
  const [editandoComplemento, setEditandoComplemento] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [formCliente, setFormCliente] = useState({ nombre: '', telefono: '', email: '', origen: '', notas: '' });
  const [formEvento, setFormEvento] = useState({ nombre_evento: '', cliente_id: '', fecha_evento: '', descripcion: '', precio_total: '', estado: 'negociacion' });
  const [erroresEvento, setErroresEvento] = useState({});
  const [anticipoDatos, setAnticiDatos] = useState({ monto: '', fecha: '', cuenta: '' });
  const [complementoDatos, setComplementoDatos] = useState({ monto: '', fecha: '', cuenta: '' });
  const [confirmModal, setConfirmModal] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [filtroMes, setFiltroMes] = useState('todos');

  const cargarClientes = useCallback(async () => {
    try {
      const r = await fetch(`${API_URL}/api/clientes`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (r.status === 401) { onLogout(); return; }
      setClientes(await r.json());
    } catch { console.log('Error cargando clientes'); }
  }, [token, onLogout]);

  const cargarEventos = useCallback(async () => {
    setCargando(true);
    try {
      const r = await fetch(`${API_URL}/api/eventos`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (r.status === 401) { onLogout(); return; }
      setEventos(await r.json());
    } catch (err) { setError('Error: ' + err.message); }
    setCargando(false);
  }, [token, onLogout]);

  useEffect(() => { cargarClientes(); cargarEventos(); }, [cargarClientes, cargarEventos]);

  const eventosFiltrados = eventos.filter(e => {
    const txt = busqueda.toLowerCase();
    return (!txt || e.nombre_evento?.toLowerCase().includes(txt) || e.cliente_nombre?.toLowerCase().includes(txt))
      && (filtroEstado === 'todos' || normalizarEstado(e.estado) === filtroEstado)
      && (filtroMes === 'todos' || (e.fecha_evento && e.fecha_evento.startsWith(filtroMes)));
  });

  const mesesDisponibles = [...new Set(eventos.filter(e => e.fecha_evento).map(e => e.fecha_evento.slice(0, 7)))].sort().reverse();

  const statsPorEstado = ['negociacion', 'confirmado', 'completado', 'cancelado'].map(key => ({
    key, ...ESTADOS[key],
    count: eventos.filter(e => normalizarEstado(e.estado) === key).length,
  }));

  const crearCliente = async (e) => {
    e.preventDefault(); setError(''); setExito('');
    try {
      const method = editandoCliente ? 'PUT' : 'POST';
      const url = editandoCliente ? `${API_URL}/api/clientes/${editandoCliente.id}` : `${API_URL}/api/clientes`;
      const r = await fetch(url, { method, headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(formCliente) });
      if (!r.ok) throw new Error('Error');
      setExito(editandoCliente ? '✅ Cliente actualizado!' : '✅ Cliente creado!');
      setFormCliente({ nombre: '', telefono: '', email: '', origen: '', notas: '' });
      setMostrarFormCliente(false); setEditandoCliente(null); cargarClientes();
    } catch (err) { setError('❌ ' + err.message); }
  };

  const crearEvento = async (e) => {
    e.preventDefault(); setError(''); setExito('');
    const errs = validarEvento(formEvento);
    if (Object.keys(errs).length > 0) { setErroresEvento(errs); return; }
    setErroresEvento({});
    try {
      const method = editandoEvento ? 'PUT' : 'POST';
      const url = editandoEvento ? `${API_URL}/api/eventos/${editandoEvento.id}` : `${API_URL}/api/eventos`;
      const r = await fetch(url, { method, headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(formEvento) });
      if (!r.ok) throw new Error('Error');
      setExito(editandoEvento ? '✅ Evento actualizado!' : '✅ Evento creado!');
      setFormEvento({ nombre_evento: '', cliente_id: '', fecha_evento: '', descripcion: '', precio_total: '', estado: 'negociacion' });
      setMostrarFormEvento(false); setEditandoEvento(null); cargarEventos(); cargarClientes();
    } catch (err) { setError('❌ ' + err.message); }
  };

  const registrarAnticipo = async (e, eventoId) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/api/eventos/${eventoId}/anticipo`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(anticipoDatos),
      });
      if (!r.ok) throw new Error('Error');
      setExito('✅ Anticipo ' + (editandoAnticipo ? 'actualizado' : 'registrado'));
      setAnticiDatos({ monto: '', fecha: '', cuenta: '' }); setEditandoAnticipo(null); cargarEventos();
    } catch (err) { setError('❌ ' + err.message); }
  };

  const registrarComplemento = async (e, eventoId) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/api/eventos/${eventoId}/complemento`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify(complementoDatos),
      });
      if (!r.ok) throw new Error('Error');
      setExito('✅ Complemento ' + (editandoComplemento ? 'actualizado' : 'registrado'));
      setComplementoDatos({ monto: '', fecha: '', cuenta: '' }); setEditandoComplemento(null); cargarEventos();
    } catch (err) { setError('❌ ' + err.message); }
  };

  const eliminarCliente = (id, nombre) => setConfirmModal({
    mensaje: `Se eliminará a "${nombre}" permanentemente.`,
    onConfirmar: async () => {
      try {
        const r = await fetch(`${API_URL}/api/clientes/${id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (!r.ok) throw new Error('Error');
        setConfirmModal(null); setExito('✅ Cliente eliminado'); cargarClientes();
      } catch { setConfirmModal(null); setError('❌ Error al eliminar'); }
    },
  });

  const eliminarEvento = (id, nombre) => setConfirmModal({
    mensaje: `Se eliminará el evento "${nombre}" y sus pagos permanentemente.`,
    onConfirmar: async () => {
      try {
        const r = await fetch(`${API_URL}/api/eventos/${id}`, {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        if (!r.ok) throw new Error('Error');
        setConfirmModal(null); setExito('✅ Evento eliminado'); cargarEventos();
      } catch { setConfirmModal(null); setError('❌ Error al eliminar'); }
    },
  });

  const cambiarEstadoEvento = async (id, nuevoKey) => {
    try {
      await fetch(`${API_URL}/api/eventos/${id}/estado`, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify({ estado: nuevoKey }) });
      setExito(`✅ Estado → ${ESTADOS[nuevoKey]?.label}`); setTimeout(() => setExito(''), 3000); cargarEventos();
    } catch { setError('❌ Error al cambiar estado'); }
  };

  return (
    <div style={{fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', minHeight: '100vh', backgroundColor: '#f8f9fa'}}>
      <script src="https://cdnjs.cloudflare.com/ajax/libs/Chart.js/4.4.1/chart.umd.min.js" />

      <header style={{backgroundColor: '#fff', borderBottom: '1px solid #e1e4e8', padding: '16px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 1px 3px rgba(0,0,0,0.05)'}}>
        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
          <img src="/logo.jpeg" alt="Sonrie Globos" style={{height: '42px', objectFit: 'contain'}} />
          <div>
            <div style={{fontSize: '18px', fontWeight: '700', color: '#172b4d'}}>Sonrie Globos</div>
            <div style={{fontSize: '11px', color: '#626f86'}}>CRM</div>
          </div>
        </div>
        <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
          <div style={{fontSize: '13px', color: '#626f86'}}>👤 {usuario?.nombre}</div>
          <button onClick={onLogout} style={{padding: '8px 16px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>Salir</button>
        </div>
      </header>

      <div style={{display: 'flex', height: 'calc(100vh - 70px)'}}>
        <nav style={{width: '240px', backgroundColor: '#fff', borderRight: '1px solid #e1e4e8', padding: '16px 0', overflowY: 'auto'}}>
          <MenuBtn icon="📊" label="Inicio"    active={seccion === 'inicio'}   onClick={() => setSeccion('inicio')} />
          <MenuBtn icon="👥" label="Clientes"  active={seccion === 'clientes'} onClick={() => setSeccion('clientes')} />
          <MenuBtn icon="🎈" label="Eventos"   active={seccion === 'eventos'}  onClick={() => setSeccion('eventos')} />
          <MenuBtn icon="🌐" label="Sitio Web" active={seccion === 'cms'}      onClick={() => setSeccion('cms')} />
        </nav>

        <main style={{flex: 1, padding: '32px', overflowY: 'auto', backgroundColor: '#f8f9fa'}}>
          {error && <div style={{backgroundColor: '#ffebee', color: '#d32f2f', padding: '12px 16px', borderRadius: '4px', marginBottom: '20px', fontSize: '13px'}}>{error}</div>}
          {exito && <div style={{backgroundColor: '#e8f5e9', color: '#388e3c', padding: '12px 16px', borderRadius: '4px', marginBottom: '20px', fontSize: '13px'}}>{exito}</div>}

          {seccion === 'inicio' && <SeccionInicio clientes={clientes} eventos={eventos} setSeccion={setSeccion} />}

          {seccion === 'clientes' && (
            <div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px'}}>
                <div>
                  <h1 style={{fontSize: '28px', fontWeight: '700', color: '#172b4d', margin: 0}}>👥 Clientes</h1>
                  <p style={{color: '#626f86', margin: '4px 0 0 0', fontSize: '14px'}}>{clientes.length} clientes</p>
                </div>
                <button onClick={() => { setEditandoCliente(null); setFormCliente({ nombre: '', telefono: '', email: '', origen: '', notas: '' }); setMostrarFormCliente(!mostrarFormCliente); }} style={{padding: '10px 20px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>+ Nuevo</button>
              </div>
              {mostrarFormCliente && (
                <div style={{backgroundColor: '#fff', padding: '24px', borderRadius: '8px', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
                  <h3 style={{margin: '0 0 20px 0', color: '#172b4d', fontSize: '16px', fontWeight: '600'}}>{editandoCliente ? 'Editar' : 'Nuevo'} Cliente</h3>
                  <form onSubmit={crearCliente}>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px'}}>
                      <InputField label="Nombre *" placeholder="Juan Pérez" value={formCliente.nombre} onChange={(e) => setFormCliente({...formCliente, nombre: e.target.value})} required />
                      <InputField label="Teléfono" placeholder="3215551234" value={formCliente.telefono} onChange={(e) => setFormCliente({...formCliente, telefono: e.target.value})} />
                    </div>
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px'}}>
                      <InputField label="Email" type="email" placeholder="juan@email.com" value={formCliente.email} onChange={(e) => setFormCliente({...formCliente, email: e.target.value})} />
                      <InputField label="Origen" placeholder="Instagram..." value={formCliente.origen} onChange={(e) => setFormCliente({...formCliente, origen: e.target.value})} />
                    </div>
                    <div style={{marginBottom: '20px'}}>
                      <label style={{display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>Notas</label>
                      <textarea placeholder="Notas..." value={formCliente.notas} onChange={(e) => setFormCliente({...formCliente, notas: e.target.value})} style={{width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', minHeight: '80px', fontFamily: 'inherit'}} />
                    </div>
                    <div style={{display: 'flex', gap: '12px'}}>
                      <button type="submit" style={{padding: '10px 20px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>{editandoCliente ? 'Actualizar' : 'Guardar'}</button>
                      <button type="button" onClick={() => setMostrarFormCliente(false)} style={{padding: '10px 20px', backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>Cancelar</button>
                    </div>
                  </form>
                </div>
              )}
              {clientes.length === 0 ? <p>No hay clientes</p> : (
                <div style={{backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
                  <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                      <tr style={{backgroundColor: '#f0f2f5', borderBottom: '1px solid #e1e4e8'}}>
                        {['Nombre', 'Teléfono', 'Email', 'Origen', 'Acciones'].map(h => <th key={h} style={{padding: '16px', textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#626f86'}}>{h}</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {clientes.map(c => (
                        <tr key={c.id} style={{borderBottom: '1px solid #e1e4e8'}}>
                          <td style={{padding: '16px', fontSize: '14px', color: '#172b4d', fontWeight: '500'}}>{c.nombre}</td>
                          <td style={{padding: '16px', fontSize: '14px', color: '#626f86'}}>{c.telefono || '-'}</td>
                          <td style={{padding: '16px', fontSize: '14px', color: '#626f86'}}>{c.email || '-'}</td>
                          <td style={{padding: '16px', fontSize: '14px', color: '#626f86'}}>{c.origen || '-'}</td>
                          <td style={{padding: '16px'}}>
                            <div style={{display: 'flex', gap: '8px'}}>
                              <button onClick={() => { setFormCliente(c); setEditandoCliente(c); setMostrarFormCliente(true); }} style={{backgroundColor: '#e3f2fd', color: '#1976d2', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>✏️ Editar</button>
                              <button onClick={() => eliminarCliente(c.id, c.nombre)} style={{backgroundColor: '#ffebee', color: '#d32f2f', border: 'none', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>🗑️ Eliminar</button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {seccion === 'eventos' && (
            <div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <div>
                  <h1 style={{fontSize: '28px', fontWeight: '700', color: '#172b4d', margin: 0}}>🎈 Eventos</h1>
                  <p style={{color: '#626f86', margin: '4px 0 0 0', fontSize: '14px'}}>{eventosFiltrados.length} de {eventos.length} eventos</p>
                </div>
                <button onClick={() => { setEditandoEvento(null); setErroresEvento({}); setFormEvento({ nombre_evento: '', cliente_id: '', fecha_evento: '', descripcion: '', precio_total: '', estado: 'negociacion' }); setMostrarFormEvento(!mostrarFormEvento); }} style={{padding: '10px 20px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>+ Nuevo</button>
              </div>

              <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', marginBottom: '20px'}}>
                {statsPorEstado.map(s => (
                  <div key={s.key} onClick={() => setFiltroEstado(filtroEstado === s.key ? 'todos' : s.key)}
                    style={{backgroundColor: filtroEstado === s.key ? s.bg : '#fff', padding: '12px 14px', borderRadius: '8px', border: `1.5px solid ${filtroEstado === s.key ? s.color : '#e1e4e8'}`, cursor: 'pointer', transition: 'all 0.15s'}}>
                    <div style={{fontSize: '11px', fontWeight: '600', color: '#626f86', marginBottom: '4px'}}>{s.label.toUpperCase()}</div>
                    <div style={{fontSize: '22px', fontWeight: '700', color: s.color}}>{s.count}</div>
                  </div>
                ))}
              </div>

              <div style={{backgroundColor: '#fff', padding: '16px', borderRadius: '8px', marginBottom: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)'}}>
                <div style={{display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center'}}>
                  <div style={{display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: '200px', border: '1px solid #ddd', borderRadius: '4px', padding: '8px 12px', backgroundColor: '#f8f9fa'}}>
                    <span style={{color: '#626f86'}}>🔍</span>
                    <input type="text" placeholder="Buscar evento o cliente..." value={busqueda} onChange={e => setBusqueda(e.target.value)} style={{border: 'none', background: 'none', fontSize: '13px', outline: 'none', width: '100%', fontFamily: 'inherit', color: '#172b4d'}} />
                    {busqueda && <button onClick={() => setBusqueda('')} style={{border: 'none', background: 'none', cursor: 'pointer', color: '#626f86', fontSize: '16px', lineHeight: 1, padding: 0}}>×</button>}
                  </div>
                  <select value={filtroMes} onChange={e => setFiltroMes(e.target.value)} style={{padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px', backgroundColor: '#f8f9fa', color: '#172b4d', fontFamily: 'inherit', cursor: 'pointer'}}>
                    <option value="todos">Todos los meses</option>
                    {mesesDisponibles.map(m => { const [a, mo] = m.split('-'); const n = new Date(Number(a), Number(mo)-1).toLocaleString('es-MX',{month:'long',year:'numeric'}); return <option key={m} value={m}>{n.charAt(0).toUpperCase()+n.slice(1)}</option>; })}
                  </select>
                  {(busqueda || filtroEstado !== 'todos' || filtroMes !== 'todos') && <button onClick={() => { setBusqueda(''); setFiltroEstado('todos'); setFiltroMes('todos'); }} style={{padding: '8px 14px', border: '1px solid #ddd', borderRadius: '4px', background: '#fff', color: '#626f86', fontSize: '12px', cursor: 'pointer', fontWeight: '600'}}>✕ Limpiar</button>}
                </div>
                <div style={{display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap'}}>
                  <button onClick={() => setFiltroEstado('todos')} style={{padding: '4px 12px', borderRadius: 20, border: `1px solid ${filtroEstado === 'todos' ? '#FF1493' : '#e1e4e8'}`, background: filtroEstado === 'todos' ? '#FFE4F0' : 'white', color: filtroEstado === 'todos' ? '#FF1493' : '#626f86', fontSize: '12px', cursor: 'pointer', fontWeight: filtroEstado === 'todos' ? 600 : 400}}>Todos ({eventos.length})</button>
                  {statsPorEstado.map(s => <button key={s.key} onClick={() => setFiltroEstado(filtroEstado === s.key ? 'todos' : s.key)} style={{padding: '4px 12px', borderRadius: 20, border: `1px solid ${filtroEstado === s.key ? s.color : '#e1e4e8'}`, background: filtroEstado === s.key ? s.bg : 'white', color: filtroEstado === s.key ? s.color : '#626f86', fontSize: '12px', cursor: 'pointer', fontWeight: filtroEstado === s.key ? 600 : 400}}>{s.label} ({s.count})</button>)}
                </div>
              </div>

              {mostrarFormEvento && (
                <div style={{backgroundColor: '#fff', padding: '24px', borderRadius: '8px', marginBottom: '24px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
                  <h3 style={{margin: '0 0 20px 0', color: '#172b4d', fontSize: '16px', fontWeight: '600'}}>{editandoEvento ? 'Editar' : 'Nuevo'} Evento</h3>
                  <form onSubmit={crearEvento} noValidate>
                    <InputField label="Nombre *" placeholder="Cumpleaños XV, Boda, Baby Shower..." value={formEvento.nombre_evento}
                      onChange={(e) => { setFormEvento({...formEvento, nombre_evento: e.target.value}); if (erroresEvento.nombre_evento) setErroresEvento({...erroresEvento, nombre_evento: ''}); }}
                      error={erroresEvento.nombre_evento} />
                    <ClienteSelector
                      clientes={clientes} value={formEvento.cliente_id}
                      onChange={(id) => { setFormEvento({...formEvento, cliente_id: id}); if (erroresEvento.cliente_id) setErroresEvento({...erroresEvento, cliente_id: ''}); }}
                      error={erroresEvento.cliente_id} token={token}
                      onClienteCreado={(nuevo) => setClientes(prev => [nuevo, ...prev])}
                    />
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px'}}>
                      <InputField label="Fecha del evento *" type="date" value={formEvento.fecha_evento}
                        onChange={(e) => { setFormEvento({...formEvento, fecha_evento: e.target.value}); if (erroresEvento.fecha_evento) setErroresEvento({...erroresEvento, fecha_evento: ''}); }}
                        error={erroresEvento.fecha_evento} />
                      <InputField label="Precio total *" type="number" placeholder="5000" value={formEvento.precio_total}
                        onChange={(e) => { setFormEvento({...formEvento, precio_total: e.target.value}); if (erroresEvento.precio_total) setErroresEvento({...erroresEvento, precio_total: ''}); }}
                        error={erroresEvento.precio_total} />
                    </div>
                    <div style={{marginBottom: '16px'}}>
                      <label style={{display: 'block', marginBottom: '6px', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>Estado</label>
                      <select value={formEvento.estado} onChange={(e) => setFormEvento({...formEvento, estado: e.target.value})} style={{width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px', boxSizing: 'border-box', fontFamily: 'inherit'}}>
                        {Object.entries(ESTADOS).map(([key, val]) => <option key={key} value={key}>{val.label}</option>)}
                      </select>
                    </div>
                    <div style={{display: 'flex', gap: '12px'}}>
                      <button type="submit" style={{padding: '10px 20px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>{editandoEvento ? 'Actualizar' : 'Guardar'}</button>
                      <button type="button" onClick={() => { setMostrarFormEvento(false); setErroresEvento({}); }} style={{padding: '10px 20px', backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>Cancelar</button>
                    </div>
                  </form>
                </div>
              )}

              {cargando ? (
                <p style={{color: '#626f86', textAlign: 'center', padding: '40px'}}>Cargando eventos...</p>
              ) : eventosFiltrados.length === 0 ? (
                <div style={{textAlign: 'center', padding: '60px 20px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)'}}>
                  <div style={{fontSize: '40px', marginBottom: '12px'}}>🔍</div>
                  <p style={{color: '#626f86', fontSize: '15px', margin: 0}}>{eventos.length === 0 ? 'No hay eventos registrados aún' : 'Sin resultados para esos filtros'}</p>
                  {eventos.length > 0 && <button onClick={() => { setBusqueda(''); setFiltroEstado('todos'); setFiltroMes('todos'); }} style={{marginTop: '12px', padding: '8px 16px', background: '#FFE4F0', color: '#FF1493', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>Ver todos</button>}
                </div>
              ) : (
                <div style={{display: 'grid', gap: '16px'}}>
                  {eventosFiltrados.map(e => {
                    const antiMonto = Number(e.anticipo) || 0, compMonto = Number(e.complemento) || 0;
                    const totalRecibido = antiMonto + compMonto, precioTotal = Number(e.precio_total) || 0;
                    const pendiente = precioTotal - totalRecibido, expandido = eventoExpandido === e.id;
                    return (
                      <div key={e.id} style={{backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)'}}>
                        <div onClick={() => setEventoExpandido(expandido ? null : e.id)} style={{padding: '18px 20px', cursor: 'pointer', backgroundColor: expandido ? '#fff5f8' : '#fff', borderBottom: expandido ? '1px solid #FFE4F0' : 'none'}}>
                          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px'}}>
                            <div style={{flex: 1}}>
                              <div style={{fontSize: '15px', fontWeight: '600', color: '#172b4d', marginBottom: '4px'}}>{e.nombre_evento}</div>
                              <div style={{display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap'}}>
                                <span style={{fontSize: '13px', color: '#626f86'}}>{e.cliente_nombre}</span>
                                {e.fecha_evento && <span style={{fontSize: '12px', color: '#626f86'}}>📅 {new Date(e.fecha_evento).toLocaleDateString('es-MX', { day: 'numeric', month: 'short', year: 'numeric' })}</span>}
                                <EstadoBadge estado={e.estado} />
                              </div>
                            </div>
                            <div style={{display: 'flex', alignItems: 'center', gap: '24px', marginLeft: '16px'}}>
                              <div style={{textAlign: 'right'}}><div style={{fontSize: '12px', color: '#626f86'}}>Precio</div><div style={{fontSize: '15px', fontWeight: '600', color: '#172b4d'}}>${precioTotal.toFixed(0)}</div></div>
                              <div style={{textAlign: 'right'}}><div style={{fontSize: '12px', color: '#626f86'}}>Cobrado</div><div style={{fontSize: '15px', fontWeight: '600', color: '#FF1493'}}>${totalRecibido.toFixed(0)}</div></div>
                              <div style={{fontSize: '20px', color: '#626f86'}}>{expandido ? '▲' : '▽'}</div>
                            </div>
                          </div>
                          <BarraPago cobrado={totalRecibido} total={precioTotal} />
                        </div>
                        {expandido && (
                          <div style={{padding: '24px', backgroundColor: '#fff5f8'}}>
                            <div style={{display: 'flex', gap: '10px', marginBottom: '24px', flexWrap: 'wrap', alignItems: 'center'}}>
                              <button onClick={() => { setFormEvento({nombre_evento: e.nombre_evento, cliente_id: e.cliente_id, fecha_evento: e.fecha_evento, descripcion: e.descripcion, precio_total: e.precio_total, estado: normalizarEstado(e.estado)}); setEditandoEvento(e); setErroresEvento({}); setMostrarFormEvento(true); }} style={{backgroundColor: '#e3f2fd', color: '#1976d2', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>✏️ Editar</button>
                              <EstadoDropdown eventoId={e.id} estadoActual={e.estado} onCambiar={cambiarEstadoEvento} />
                              <button onClick={() => eliminarEvento(e.id, e.nombre_evento)} style={{backgroundColor: '#ffebee', color: '#d32f2f', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: '600'}}>🗑️ Eliminar</button>
                            </div>
                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px'}}>
                              <div><div style={{fontSize: '12px', fontWeight: '600', color: '#626f86', marginBottom: '8px'}}>FECHA</div><div style={{fontSize: '14px', color: '#172b4d'}}>{e.fecha_evento ? new Date(e.fecha_evento).toLocaleDateString('es-MX',{weekday:'long',day:'numeric',month:'long',year:'numeric'}) : '-'}</div></div>
                              <div><div style={{fontSize: '12px', fontWeight: '600', color: '#626f86', marginBottom: '8px'}}>PENDIENTE</div><div style={{fontSize: '14px', color: pendiente > 0 ? '#d32f2f' : '#4caf50', fontWeight: '600'}}>${pendiente.toFixed(2)}</div></div>
                            </div>
                            <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px'}}>
                              <div>
                                <h4 style={{margin: '0 0 16px 0', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>📍 Anticipo</h4>
                                {e.anticipo_registrado && <div style={{backgroundColor: '#e8f5e9', padding: '12px', borderRadius: '4px', marginBottom: '12px'}}><div style={{fontSize: '13px', fontWeight: '600', color: '#2e7d32'}}>✅ ${antiMonto.toFixed(2)}</div><div style={{fontSize: '12px', color: '#558b2f'}}>{e.fecha_anticipo ? new Date(e.fecha_anticipo).toLocaleDateString('es-MX') : '-'}</div><div style={{fontSize: '12px', color: '#558b2f'}}>{e.cuenta_anticipo}</div></div>}
                                {editandoAnticipo === e.id ? (
                                  <form onSubmit={(ev) => registrarAnticipo(ev, e.id)} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                    <input type="number" step="0.01" placeholder="Monto" value={anticipoDatos.monto} onChange={(ev) => setAnticiDatos({...anticipoDatos, monto: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="date" value={anticipoDatos.fecha} onChange={(ev) => setAnticiDatos({...anticipoDatos, fecha: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="text" placeholder="Cuenta / Método" value={anticipoDatos.cuenta} onChange={(ev) => setAnticiDatos({...anticipoDatos, cuenta: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <div style={{display: 'flex', gap: '8px'}}>
                                      <button type="submit" style={{padding: '6px 12px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', flex: 1}}>Guardar</button>
                                      <button type="button" onClick={() => setEditandoAnticipo(null)} style={{padding: '6px 12px', backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', flex: 1}}>Cancelar</button>
                                    </div>
                                  </form>
                                ) : e.anticipo_registrado ? (
                                  <button onClick={() => { setAnticiDatos({monto: e.anticipo || '', fecha: e.fecha_anticipo || '', cuenta: e.cuenta_anticipo || ''}); setEditandoAnticipo(e.id); }} style={{width: '100%', backgroundColor: '#fff3e0', color: '#e65100', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>✏️ Editar anticipo</button>
                                ) : (
                                  <form onSubmit={(ev) => registrarAnticipo(ev, e.id)} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                    <input type="number" step="0.01" placeholder="Monto" value={anticipoDatos.monto} onChange={(ev) => setAnticiDatos({...anticipoDatos, monto: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="date" value={anticipoDatos.fecha} onChange={(ev) => setAnticiDatos({...anticipoDatos, fecha: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="text" placeholder="Cuenta / Método" value={anticipoDatos.cuenta} onChange={(ev) => setAnticiDatos({...anticipoDatos, cuenta: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <button type="submit" style={{padding: '8px 12px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>Registrar anticipo</button>
                                  </form>
                                )}
                              </div>
                              <div>
                                <h4 style={{margin: '0 0 16px 0', fontSize: '13px', fontWeight: '600', color: '#172b4d'}}>💳 Complemento</h4>
                                {e.complemento_registrado && <div style={{backgroundColor: '#e8f5e9', padding: '12px', borderRadius: '4px', marginBottom: '12px'}}><div style={{fontSize: '13px', fontWeight: '600', color: '#2e7d32'}}>✅ ${compMonto.toFixed(2)}</div><div style={{fontSize: '12px', color: '#558b2f'}}>{e.fecha_complemento ? new Date(e.fecha_complemento).toLocaleDateString('es-MX') : '-'}</div><div style={{fontSize: '12px', color: '#558b2f'}}>{e.cuenta_complemento}</div></div>}
                                {editandoComplemento === e.id ? (
                                  <form onSubmit={(ev) => registrarComplemento(ev, e.id)} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                    <input type="number" step="0.01" placeholder="Monto" value={complementoDatos.monto} onChange={(ev) => setComplementoDatos({...complementoDatos, monto: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="date" value={complementoDatos.fecha} onChange={(ev) => setComplementoDatos({...complementoDatos, fecha: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="text" placeholder="Cuenta / Método" value={complementoDatos.cuenta} onChange={(ev) => setComplementoDatos({...complementoDatos, cuenta: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <div style={{display: 'flex', gap: '8px'}}>
                                      <button type="submit" style={{padding: '6px 12px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', flex: 1}}>Guardar</button>
                                      <button type="button" onClick={() => setEditandoComplemento(null)} style={{padding: '6px 12px', backgroundColor: '#f0f2f5', color: '#172b4d', border: '1px solid #ddd', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', flex: 1}}>Cancelar</button>
                                    </div>
                                  </form>
                                ) : e.complemento_registrado ? (
                                  <button onClick={() => { setComplementoDatos({monto: e.complemento || '', fecha: e.fecha_complemento || '', cuenta: e.cuenta_complemento || ''}); setEditandoComplemento(e.id); }} style={{width: '100%', backgroundColor: '#fff3e0', color: '#e65100', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>✏️ Editar complemento</button>
                                ) : (
                                  <form onSubmit={(ev) => registrarComplemento(ev, e.id)} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                                    <input type="number" step="0.01" placeholder="Monto" value={complementoDatos.monto} onChange={(ev) => setComplementoDatos({...complementoDatos, monto: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="date" value={complementoDatos.fecha} onChange={(ev) => setComplementoDatos({...complementoDatos, fecha: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <input type="text" placeholder="Cuenta / Método" value={complementoDatos.cuenta} onChange={(ev) => setComplementoDatos({...complementoDatos, cuenta: ev.target.value})} required style={{padding: '8px 10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '13px'}} />
                                    <button type="submit" style={{padding: '8px 12px', backgroundColor: '#FF1493', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: '600'}}>Registrar complemento</button>
                                  </form>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {seccion === 'cms' && (
            <div>
              <div style={{marginBottom: 24}}>
                <h1 style={{fontSize: '28px', fontWeight: '700', color: '#172b4d', margin: '0 0 4px'}}>🌐 Sitio Web</h1>
                <p style={{color: '#626f86', margin: 0, fontSize: '14px'}}>Edita el contenido de tu landing page sin tocar código.</p>
              </div>
              <SeccionCMS token={token} />
            </div>
          )}
        </main>
      </div>

      {confirmModal && <ConfirmModal mensaje={confirmModal.mensaje} onConfirmar={confirmModal.onConfirmar} onCancelar={() => setConfirmModal(null)} />}
    </div>
  );
}

export default Dashboard;
